import { ActionType, getActionTypeFromInstance } from '@ngxs/store';

import { ApiFilterValues, ApiGetListResponse, ApiGetRequest, ApiSearchValues } from '../../models/api.models';

export interface ApiListEmit<T extends object> {
  readonly response: ApiGetListResponse<T>;
}

export class ApiGetAction<T extends object> {
  constructor(readonly options?: Partial<ApiGetRequest<T>>) {}
}

export function ApiListEmitAction<T extends object>(action: unknown) {
  return class {
    static readonly type = `${getActionTypeFromInstance(action)} Emitted`;

    constructor(readonly response: ApiGetListResponse<T>) {}
  };
}

export class ApiListRefresh {
  static readonly type = `[API] Refresh List`;

  constructor(readonly action: ActionType) {}
}

export class ApiListReset {
  static readonly type = `[API] Reset List`;

  constructor(readonly action: ActionType) {}
}

export class ApiListLoadMore {
  static readonly type = `[API] List Load More`;

  constructor(readonly action: ActionType) {}
}

export class ApiListSetPage {
  static readonly type = `[API] List Set Page`;

  constructor(
    readonly action: ActionType,
    readonly pageIndex: number,
  ) {}
}

export class ApiListSetLimit {
  static readonly type = `[API] List Set Limit`;

  constructor(
    readonly action: ActionType,
    readonly limit: number,
  ) {}
}

export class ApiListLoadAll {
  static readonly type = `[API] List Load All`;

  constructor(readonly action: ActionType) {}
}

export class ApiListSort<T extends object> {
  static readonly type = `[API] List Sort`;

  constructor(
    readonly action: ActionType,
    readonly sortValues: ApiGetRequest<T>['sortValues'],
  ) {}
}

export class ApiListSearch {
  static readonly type = `[API] List Search`;

  constructor(
    readonly action: ActionType,
    readonly searchTerm: string,
  ) {}
}

export class ApiListUpdateFilterValues<T extends object> {
  static readonly type = `[API] Update filter values`;

  constructor(
    readonly action: ActionType,
    readonly filterValues: ApiFilterValues<T>,
  ) {}
}

export class ApiListSetFilterValues<T extends object> {
  static readonly type = `[API] Set filter values`;

  constructor(
    readonly action: ActionType,
    readonly filterValues: ApiFilterValues<T>,
  ) {}
}

export class ApiListSetSearchValues<T extends object> {
  static readonly type = `[API] Set search values`;

  constructor(
    readonly action: ActionType,
    readonly searchValues: ApiSearchValues<T>,
  ) {}
}

export class ApiListConnect {
  static readonly type = `[API] List Connect`;

  constructor(readonly action: ActionType) {}
}

export class ApiListDisconnect {
  static readonly type = `[API] List Disconnect`;

  constructor(readonly action: ActionType) {}
}
